module.exports = require("./ar-SA");